
import { PDFDocument } from 'pdf-lib';
import { PDFName,PDFCheckBox } from 'pdf-lib';
import { rgb, StandardFonts } from 'pdf-lib';
const token = localStorage.getItem("accessToken");
const API_URL2 = process.env.REACT_APP_BACKEND_URL;
  const calcNetWages = emp => {
    const rate = Number(emp.pay_rate) || 0;
    const units = Number(emp.pay_units) || 0;
    const frequencyFactor = (() => {
      switch (emp.pay_schedule) {
        case 'hourly': return (units * 52) / 12;
        case 'weekly': return 52 / 12;
        case 'biweekly': return 26 / 12;
        case 'semimonthly': return 2;
        case 'monthly': return 1;
        case 'yearly': return 1 / 12;
        default: return 0;
      }
    })();
    const gross = rate * frequencyFactor;
    const deductions = (emp.deductions || []).reduce((sum, d) => sum + Number(d.amount || 0), 0);
    return gross - deductions;
  };
  export function getTotalIncome(caseData){
    let combined = 0;
    caseData.debtors.forEach((debtor, idx) => {
        
        const contribEntries = debtor.expense_contributions || [];
        const contribAmount = contribEntries.reduce((sum, c) => sum + Number(c.amount || 0), 0);
        combined += contribAmount
        const businessEntries = debtor.business_incomes || [];
        const totalNetBusiness = businessEntries
        .map(b => {
            const gross = Number(b.gross_revenue) || 0;
            const expensesSum = (b.expenses || []).reduce((sum, e) => sum + Number(e.amount || 0), 0);
            return gross - expensesSum;
        })
        .reduce((sum, n) => sum + n, 0);
        combined += totalNetBusiness
        const govEntries = debtor.gov_assistances || [];
        const govAmount = govEntries.reduce((s, g) => s + Number(g.amount || 0), 0);

        const otherEntries = (debtor.other_income_items || []).map(o => ({
          name: o.name,
          amount: Number(o.amount || 0),
        }));
        const otherAmount = otherEntries.reduce((s, o) => s + Number(o.amount || 0), 0);

        const fixedNonWage = (Number(debtor.interest_dividend_income) || 0)
          + (Number(debtor.family_support_payments) || 0)
          + (Number(debtor.social_security_income) || 0)
          + (Number(debtor.unemployment_income) || 0)
          + (Number(debtor.pension_income) || 0);

        const totalNonWage = fixedNonWage + govAmount + otherAmount;
        combined += totalNonWage;
            debtor.employments.forEach((empX, idxX) => {
        const netX = calcNetWages(empX);
        combined += netX
        });
        })
        return combined
}

function moveUncheckedCheckboxesToCorner(form, pageSize, context) {
  const { width, height } = pageSize;
  form.getFields().forEach(field => {
    // Only target PDFCheckBox fields
    if (field instanceof PDFCheckBox) {
      try {
        if (!field.isChecked()) {
          const widgets = field.acroField.getWidgets();
          widgets.forEach(widget => {
            const dict = widget.acroAnnotation?.dict || widget.dict;
            dict.set(
              PDFName.of('Rect'),
              context.obj([
                width + 5,
                height + 5,
                width + 15,
                height + 15
              ])
            );
          });
        }
      } catch {
        // ignore any errors moving individual checkboxes
      }
    }
  });
}

async function fetchPdf(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error('Failed to fetch PDF: ' + url);
  return new Uint8Array(await res.arrayBuffer());

}

export async function generateSummary(caseData, data, expenses, installmentPayments = [], meansTestIncomes = [], realProperties = [],vehicles = [],householdItems = [],financialAssets = [],businessAssets = [],farmAssets = [],otherProperties = [],creditors = []) {

    const realPropertyAmount = realProperties.reduce((sum, p) => sum + (parseFloat(p.value_ownership_portion) || 0), 0);
    const vehicleTotal = vehicles.reduce((sum, p) => sum + (parseFloat(p.value_ownership_portion) || 0), 0);
    const householdTotal = householdItems.reduce((sum, p) => sum + (parseFloat(p.value) || 0), 0);
    const financialTotal =
  (financialAssets.cash || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.deposits || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.brokerage_accounts || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.nonpublic_stocks || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.retirement_accounts || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.security_deposits || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.annuities || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.education_iras || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.trusts || []).reduce((sum, item) => sum + (item.amount || 0), 0)+
  (financialAssets.patents || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.franchises || []).reduce((sum, item) => sum + (item.amount || 0), 0)+
  (financialAssets.tax_refunds || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.obligations || []).reduce((sum, item) => sum + (item.amount || 0), 0)+
  (financialAssets.other_amounts_owed || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.insurance_interests || []).reduce((sum, item) => sum + (item.amount || 0), 0)+
  (financialAssets.inheritance_interests || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.lawsuit_interests || []).reduce((sum, item) => sum + (item.amount || 0), 0)+
  (financialAssets.contingent_claims || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (financialAssets.other_financial_assets || []).reduce((sum, item) => sum + (item.amount || 0), 0);

    const businessTotal =
    (businessAssets.accounts_receivable || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
    (businessAssets.office_equipments || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
    (businessAssets.machinery_equipments || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
    (businessAssets.inventories || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
    (businessAssets.partnership_interests || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
    (businessAssets.customer_lists || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
    (businessAssets.other_business_properties || []).reduce((sum, item) => sum + (item.amount || 0), 0);
const farmTotal =
  (farmAssets.farm_animals || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (farmAssets.crops || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (farmAssets.farm_equipments || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (farmAssets.supplies_feed || []).reduce((sum, item) => sum + (item.amount || 0), 0) +
  (farmAssets.other_farm_properties || []).reduce((sum, item) => sum + (item.amount || 0), 0);

  const otherPropertyItems = Array.isArray(otherProperties) ? otherProperties : [];
    const personalPropertyTotal = vehicleTotal + householdTotal + financialTotal + businessTotal + farmTotal + otherPropertyItems.reduce((sum, item) => sum + (item.amount || 0), 0);


    const securedDebts = data.debtsD.filter(d => d.debt_type === 'secured' && !d.additional_notified);
    const totalSecuredBalance = securedDebts
  .reduce((sum, c) => sum + parseFloat(c.balance || 0), 0);
  const priorityDebts = data.debtsE.filter(d => d.debt_type === 'priority' && !d.additional_notified);
    const totalPriorityBalance = priorityDebts
  .reduce((sum, c) => sum + parseFloat(c.balance || 0), 0);
    const unsecuredDebts = data.debtsF.filter(d => d.debt_type === 'unsecured' && !d.additional_notified);
    const totalUnsecuredBalance = unsecuredDebts
  .reduce((sum, c) => sum + parseFloat(c.balance || 0), 0);

    console.log(totalSecuredBalance.toString())
    console.log(totalPriorityBalance.toString())
    console.log(totalUnsecuredBalance.toString())

    let expenseContribAmounts = [];
    const combined = getTotalIncome(caseData);

  const j1ExpenseItems = expenses.filter(e => !e.j2);
  const j2ExpenseItems = expenses.filter(e => e.j2);
  const j1Installments = installmentPayments
    .filter(p => !p.j2)
    .map(p => ({ amount: Number(p.amount || 0), description: p.description }));
  const j2Installments = installmentPayments
    .filter(p => p.j2)
    .map(p => ({ amount: Number(p.amount || 0), description: p.description }));
  const j1Expenses = j1ExpenseItems.concat(j1Installments);
  const j2Expenses = j2ExpenseItems.concat(j2Installments);
    const j1Total = j1Expenses.reduce((sum, e) => sum + Number(e.amount || 0), 0);
  const j2Total = j2Expenses.reduce((sum, e) => sum + Number(e.amount || 0), 0);

  const totalExpense = j1Total + j2Total
  console.log(totalExpense)



const totalMonthly = inc => (
    ['gross_wages','alimony','household_expenses','biz_net_monthly',
    'real_net_monthly','interest_dividends','unemployment','pension']
    .reduce((sum, k) => sum + (parseFloat(inc[k]) || 0), 0) +
    (inc.other_incomes?.reduce((s,o) => s + (parseFloat(o.amount)||0), 0) || 0)
);
  const inc1 = meansTestIncomes.find(inc => inc.debtor.is_primary) || {};
  const inc2 = meansTestIncomes.find(inc => !inc.debtor.is_primary) || {};
  const m1 = totalMonthly(inc1);
  const m2 = totalMonthly(inc2);
  const combinedMonthly = m1 + m2;

  console.log(combinedMonthly)
  const sumBy = (arr, field)=>arr.reduce((s,c)=>s+(parseFloat(c[field])||0),0);
  const totalDSO = sumBy(priorityDebts.filter(d=>(d.priority_type||'').toLowerCase()==='dso'), 'priority_amount')
  const totalTax = sumBy(priorityDebts.filter(d=>(d.priority_type||'').toLowerCase()==='tax'), 'priority_amount')
  const totalIntox = sumBy(priorityDebts.filter(d=>(d.priority_type||'').toLowerCase()==='intox'), 'priority_amount')
  const totalOtherPriority = 
        sumBy(priorityDebts.filter(d=>{
          const t=(d.priority_type||'').toLowerCase();
          return t && !['dso','tax','intoxicated'].includes(t);
        }),'priority_amount')

const un = data.debtsF.filter(d=>d.debt_type==='unsecured' && !d.additional_notified);
      const filterSum=(type)=>sumBy(un.filter(d=>{
        const at=(d.account_type||'').toLowerCase();
        if(type==='student_loan') return at.includes('student');
        if(type==='divorce') return at.includes('divorce');
        if(type==='pension') return at.includes('pension');
        if(type==='other') return !['student','divorce','pension'].some(k=>at.includes(k));
        return false;
      }),'balance');


      const sumBytes = await fetch('/forms/sum.pdf').then(r=>r.arrayBuffer());
      const sumDoc = await PDFDocument.load(sumBytes);
      const pageSum = sumDoc.getPage(0);
      const formSum = sumDoc.getForm();


      formSum.getTextField('student_loans').setText(filterSum('student_loan').toFixed(2));
      formSum.getTextField('divorce').setText(filterSum('divorce').toFixed(2));
      formSum.getTextField('pension').setText(filterSum('pension').toFixed(2));
      formSum.getTextField('intox').setText(totalIntox.toFixed(2));
      formSum.getTextField('taxes').setText(totalTax.toFixed(2));
      formSum.getTextField('dso').setText(totalDSO.toFixed(2));
      const totalSpecial = totalIntox + totalTax + totalDSO + filterSum('divorce') + filterSum('student_loan') + filterSum('pension')
      console.log(combined)
      formSum.getTextField('total_special').setText(totalSpecial.toFixed(2));
      formSum.getTextField('total_monthly').setText(combinedMonthly.toFixed(2));
      formSum.getTextField('total_expense').setText(totalExpense.toFixed(2));
      formSum.getTextField('total_income').setText(combined.toFixed(2));
      formSum.getTextField('total_secured').setText(totalSecuredBalance.toFixed(2));
      formSum.getTextField('total_priority').setText(totalPriorityBalance.toFixed(2));
      formSum.getTextField('total_unsecured').setText(totalUnsecuredBalance.toFixed(2));
      formSum.getTextField('total_debt').setText((totalSecuredBalance + totalPriorityBalance+ totalUnsecuredBalance).toFixed(2));
      formSum.getTextField('total_real').setText(realPropertyAmount.toFixed(2));
      formSum.getTextField('total_personal').setText(personalPropertyTotal.toFixed(2));
      formSum.getTextField('total_prop').setText((personalPropertyTotal + realPropertyAmount).toFixed(2));

      formSum.getCheckBox('always_checked').check()
      if (caseData.debt_type === 'consumer') formSum.getCheckBox('consumer_yes').check()
        else formSum.getCheckBox('consumer_no').check()

  const caseDebtors = [];

  const primaryDebtor = caseData?.debtors?.find(d => d.is_primary && d.is_filing);
  const secondaryDebtor = caseData?.debtors?.find(d => !d.is_primary && d.is_filing);
  const nonFilingSpouse = caseData?.debtors?.find(d => !d.is_primary && !d.is_filing);
  caseDebtors.push(primaryDebtor)
    if (secondaryDebtor) caseDebtors.push(secondaryDebtor)
    if (nonFilingSpouse) caseDebtors.push(nonFilingSpouse)
  // Debtor names, case, district
  if (primaryDebtor){ formSum.getTextField('Debtor 1').setText(
    [primaryDebtor.first_name, primaryDebtor.second_name, primaryDebtor.last_name]
      .filter(Boolean).join(' ')
  )

}
  if (secondaryDebtor) {formSum.getTextField('Debtor 2').setText(
    [secondaryDebtor.first_name, secondaryDebtor.second_name, secondaryDebtor.last_name]
      .filter(Boolean).join(' '))
};
  formSum.getTextField('district').setText('Eastern District of Tennessee');
  formSum.getTextField('case_number').setText(caseData?.case_number || '');
  
  moveUncheckedCheckboxesToCorner(formSum,sumDoc.getPages()[0].getSize(), sumDoc.context);
    formSum.flatten();

   const filledBytes = await sumDoc.save();
const blob = new Blob([filledBytes], { type: 'application/pdf' });
    const formData2 = new FormData();
    formData2.append('file', blob, 'draft.pdf');

  let finalBlob
  
  const primaryName = [primaryDebtor.first_name, primaryDebtor.second_name, primaryDebtor.last_name].filter(Boolean).join(' ');

const response = await fetch(`${API_URL2}/optimize-pdf/`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData2,
        credentials: 'include',
      });

      if (response.ok) {
        finalBlob = await response.blob();
      } else {
        console.error("Optimization failed");
        finalBlob = blob;  // fallback to original merged blob
      }

      // Optional: trigger download here
      //const link = document.createElement('a');
      //link.href = URL.createObjectURL(finalBlob);
      //link.download = response.ok ? `${primaryName}_Summary.pdf` : `${primaryName}_Summary-failed.pdf`;
      //link.click();

      return finalBlob
}